export const includedOptions = [
  {
    key: 'freeDrinkingWater',
    label: 'Free Drinking Water',
  },
  {
    key: 'parkingPass',
    label: 'Parking Pass',
  },
];

export const addonsTypeOptions = [
  { key: 'fixed', label: 'Fixed' },
  //{ key: 'daily', label: 'Daily' },
  { key: 'perPerson', label: 'Per person' },
];
